<ng-container *ngIf="cart$ | async as cart">
  <ng-container *ngIf="entries$ | async as entries; else emptyCart">
    <div *ngIf="cart.totalItems > 0" class="cart-details-wrapper">
      <eb-cart-item-list
        [items]="entries"
        [cartIsLoading]="!(cartLoaded$ | async)"
        [displayEntriesCompact]="true"
        class="cart-details__item-list"
      ></eb-cart-item-list>
    </div>
  </ng-container>
</ng-container>

<ng-template #emptyCart>
  <div class="cart-empty__title" data-cy="cart-empty">
    {{ 'empty.title' | cxTranslate }}
  </div>
  <div class="cart-empty__description">
    {{ 'empty.description' | cxTranslate }}
  </div>
</ng-template>
